import type { RoleDto, ContributorRole, RoleSlotDto } from '@/types/dtos/contributors/response/contributor.dto';

/** Whether the configure-remote-speaker API should enable (true) or disable (false) remote speakership. */
export function resolveFlowRemoteSpeakerConfigureEnabled(params: {
  role: RoleDto<ContributorRole> | undefined;
  roleSlot?: RoleSlotDto;
  useSlotContext: boolean;
  contributorRemoteSpeakerEnabled?: boolean;
}): boolean {
  return !resolveFlowRemoteSpeakerMenuShowsRemote(params);
}

export function resolveFlowRemoteSpeakerMenuShowsRemote(params: {
  role: RoleDto<ContributorRole> | undefined;
  roleSlot?: RoleSlotDto;
  useSlotContext: boolean;
  contributorRemoteSpeakerEnabled?: boolean;
}): boolean {
  const { role, roleSlot, useSlotContext, contributorRemoteSpeakerEnabled } = params;

  if (useSlotContext) {
    return roleSlot?.isRemoteSpeaker === true;
  }

  const hasRemoteFlowSlot =
    role?.slots?.some((slot) => slot.deleted !== true && slot.isRemoteSpeaker === true) ?? false;

  return hasRemoteFlowSlot || contributorRemoteSpeakerEnabled === true;
}
